/**
 * Returns a curried function of `f`
 *
 * @example
 * ```ts
 * const add = (a: number, b: number): number => a + b
 *
 * const curried = curry(add)
 * const add10 = curried(10)
 * console.log(add10(5)) // 15
 * console.log(curried(3, 4)) // 7
 * ```
 */
function curry(f) {
    const arity = f.length;
    return (function resolver(...args) {
        const memory = [...args];
        return function (...innerArgs) {
            const local = [...memory, ...innerArgs];
            const next = local.length >= arity ? f : resolver;
            return next(...local);
        };
    })();
}
export default curry;
//# sourceMappingURL=curry.js.map